import React from "react";
import cn from "classnames";

import { useSelector } from "react-redux";

import { getTheme } from "src/selectors";
import { StatusProps } from "./types";
import { useContent } from "src/hooks";

import styles from "./style.module.scss";

import Border from "src/assets/images/background-status-border.svg";

export const useStatus = (props: StatusProps) => {
  const content = useContent();

  const theme = useSelector(getTheme);

  const getStatusProps = React.useCallback(
    () => ({
      className: cn(styles[content], styles[theme]),
    }),
    [content, theme]
  );

  const getGameProps = React.useCallback(
    () => ({
      game: props.game,
    }),
    [props.game]
  );

  const getLapsProps = React.useCallback(
    () => ({
      game: props.game,
    }),
    [props.game]
  );

  const getTimeProps = React.useCallback(
    () => ({
      game: props.game,
    }),
    [props.game]
  );

  const getBorderProps = React.useCallback(
    () => ({
      className: cn(styles.border),
      src: Border,
    }),
    []
  );

  return {
    getBorderProps,
    getGameProps,
    getLapsProps,
    getTimeProps,
    getStatusProps,
  };
};
